import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import { goToRelativeRoute } from "modules/Services";
export default store => ({
  path: "manage-family",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-manage-family" */ "./components"),
        import(
          /* webpackChunkName: "course-manage-family" */ "./modules/ManageFamilyModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "SchoolSetup/routes/Students/components/BulkActions/modules/BulkActionsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "manageFamily",
          reducer,
        });
        injectReducer(store, {
          key: importedModule2.NAME,
          reducer: importedModule2.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (
      _.nth(nextState.routes, -2)?.path == "schoolSetup" &&
      _.last(nextState.routes).path == "manage-family"
    ) {
      const route = getNextMenuRoute("FAMILY_MEMBERS");
      if (route) {
        const goToNewRoute = goToRelativeRoute({
          route: getRelativePath(route),
        });
        store?.dispatch(goToNewRoute);
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
